import { SBFile } from '../types';

export const formatBytes = (bytes: number): string => {
  const divisor = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const power = Math.floor(Math.log(bytes) / Math.log(divisor));
  return (
    parseFloat((bytes / Math.pow(divisor, power)).toFixed(2)) +
    ' ' +
    sizes[power]
  );
};

export const getFile = (
  file: File,
  currentFiles: SBFile[],
  fileTypes?: string,
  size?: number,
): SBFile => {
  const newFile = makeDisplayFile(file);
  if (size && file.size > size) {
    return {
      ...newFile,
      error: true,
      message: `File must be under ${formatBytes(size + 1)}`,
    };
  }

  if (fileTypes) {
    const types = fileTypes.split(',').map((type) => type.trim());
    const matchesType = types.some((type) => {
      if (file.name.endsWith(type)) {
        return true;
      }
    });
    if (!matchesType) {
      return {
        ...newFile,
        error: true,
        message: `File must be type ${fileTypes}`,
      };
    }
  }

  const duplicate = currentFiles.some(
    (currentFile) => currentFile.name === file.name,
  );
  if (duplicate) {
    return {
      ...newFile,
      error: true,
      message: `File ${file.name} already selected`,
    };
  }

  return {
    ...newFile,
    new: true,
  };
};

export const removeInvalidFile = (file: SBFile, files: SBFile[]): SBFile[] => {
  return files.filter((currentFile) =>
    currentFile.name !== file.name ? true : currentFile.error ? false : true,
  );
};

export const removeFile = (file: SBFile, files: SBFile[]): SBFile[] => {
  return files.filter(
    (currentFile) =>
      currentFile.name !== file.name ||
      (currentFile.name === file.name && currentFile.error),
  );
};

export const getValidFiles = (files: SBFile[]): SBFile[] => {
  return files.filter((currentFile) => !currentFile.error);
};

export const makeDisplayFile = (file: File): SBFile => {
  return {
    name: file.name,
    lastModified: file.lastModified,
    size: file.size,
    type: file.type,
  };
};
